namespace Solovis.Reports.Parameters.Composites {


    export class CompositeSelectionSetParameterControl extends Solovis.UI.BaseControl {

        public initialParameterValue;
        public currentCompositeSelectionSet;

        public selectedCompositeSelectionSetLabel;
        public selectCompositeSelectionSetLink;

        static hasNewRender = true;
        private selectRef;

        constructor(options) {
            super(options);

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentCompositeSelectionSet = this.initialParameterValue;
        }


        public static preload(newValue, callback): void {
            if (newValue && (newValue.id || newValue.name)) {
                var loadOptions: any = { compositeSelectionSet: {} };
                if (newValue.id)
                    loadOptions.compositeSelectionSet.id = newValue.id;
                if (newValue.name)
                    loadOptions.compositeSelectionSet.name = newValue.name;

                Solovis.Reports.ReportDataLoader.loadDataSetAsync(
                    "/Solovis/Metadata/ParameterLoad",
                    loadOptions,
                    function (response, success) {
                        if (success) {
                            var dataSet = response.result.dataSet;
                            var compositeSelectionSetData = dataSet.compositeSelectionSet ? dataSet.compositeSelectionSet : null;
                            callback(compositeSelectionSetData, true);
                        }
                        else {
                            callback(null, false);
                        }
                    });
            }
            else {
                callback(null, true);
            }
        };

        public static shouldPreload(value): boolean {
            if (!value || ((value.id && value.name) || value.custom)) {
                // Already loaded.
                return false;
            }

            return true;
        }

        public static getLabel(value): string | undefined {
            if (!value) {
                return undefined;
            }
            return value.custom ? "(Ad-Hoc)" : value.name;
        }

        public static serializeParameterValue(value): any {
            if (value) {
                if (value.id) {
                    return { id: value.id };
                }
                else if (value.custom) {
                    return { custom: value.custom };
                }
            }

            return null;
        }

        public doInit() {
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        private async doRenderNew() {
            const self = this;


            let initialValue = self.initialParameterValue;
            if (initialValue && initialValue.custom) {
                //set input text to ad-hoc
                initialValue = {
                    label: "(Ad-Hoc)",
                    entry: initialValue,
                }
            }
            await Solovis.UX.Utils.placeComponent("AsyncSelect", self.container[0], {
                cacheOptions: false, //false so that if you create a new selection set it will find it
                filterOption: (option, input: string) => {
                    return (option.label as string).toLowerCase().indexOf(input.toLocaleLowerCase()) > -1
                },
                defaultValue: initialValue,
                getOptionLabel: (option) => option.label,
                getOptionValue: (option) => option.id,
                loadOptions: () => new Promise(async (resolve, reject) => {
                    let customValue = {};
                    const options = [];
                    if (self.currentCompositeSelectionSet && self.currentCompositeSelectionSet.custom) {
                        // We'll reuse the custom value so you don't lose your query when re-selecting (Ad-hoc).
                        customValue = self.currentCompositeSelectionSet.custom;
                    };
                    await Solovis.Reports.ReportDataLoader.loadDataSetAsync(
                        "/Solovis/Metadata/CompositeSelectionSetList",
                        {},
                        function (response) {
                            $(response.result.dataSet.compositeSelectionSets).each(function (i, set: any) {
                                var option = {
                                    id: set.id,
                                    label: set.name,
                                    entry: set
                                };

                                if (set.category) {
                                    option.label = option.label + " (" + set.category + ")";
                                }

                                options.push(option);
                            });
                        },
                        {
                            invokeMethod: "invoke"
                        });
                    return resolve(options);
                }),
                onChange: (selectedItem) => {
                    self.setParameterValue(selectedItem.entry);
                },
                onOptionEdit: (selectedItem) => {
                    self.setParameterValue(selectedItem.entry);
                    self._convertToAdHoc(true);
                },
                ref: (ref) => {
                    self.selectRef = ref;
                },
            });
        }

        public slotRenderFunction(slotContainer) {
            const self = this;
            $("<a>")
                .html("<span>Ad-Hoc</span>")
                .css("color", "#1E5AB4")
                .click(function () {
                    //if it is already custom open the editor
                    if (self.currentCompositeSelectionSet.custom) {
                        self._showAdHocEditor(self.currentCompositeSelectionSet.custom);
                    } else {
                        self._convertToAdHoc(true);
                    }
                })
                .appendTo(slotContainer);
        }

        public doRenderClassic() {
            var self = this;

            this.selectedCompositeSelectionSetLabel = $("<a>").appendTo(this.container);
            Solovis.UI.PopupLinkPanel.onElementClick(this.selectedCompositeSelectionSetLabel, function (e) {
                self._showSelectedSetContextMenu(e);
            });

            this.selectCompositeSelectionSetLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

            this.selectCompositeSelectionSetLink.click(function () {
                self._toggleSelectorDialog(function (compositeSelectionSet) {
                    self._setCurrentCompositeSelectionSetData(compositeSelectionSet);
                    self.notifyParameterValueChanged();
                });
            });

            // Set initial parameter value text.
            if (this.currentCompositeSelectionSet) {
                this._setCurrentCompositeSelectionSetData(this.currentCompositeSelectionSet);
            }

            // Setup drop handler for Solovis reference.
            Solovis.Site.DragDropManager.setupSolovisRefDrop(this.container, function (solovisRef) {
                if (solovisRef.type == "compositeSelectionSet") {
                    self.setParameterValue(solovisRef.value);
                }
            });

            // Setup drag handler.
            Solovis.Reports.ReportLinker.setupSolovisRefLink(
                this.selectedCompositeSelectionSetLabel,
                function () {
                    var paramValue = CompositeSelectionSetParameterControl.serializeParameterValue(self.getParameterValue());
                    return { type: "compositeSelectionSet", value: paramValue };
                });
        }


        public _updateSelectionSetLabel() {
            const enabled = this.options.renderMode === 'modern';
            if (enabled) return; //new render doesn't need to handle label
            if (this.currentCompositeSelectionSet) {
                if (this.currentCompositeSelectionSet.custom) {
                    this.selectedCompositeSelectionSetLabel.text("(Ad-Hoc) ");
                }
                else {
                    this.selectedCompositeSelectionSetLabel.text(this.currentCompositeSelectionSet.name + " ");
                }
            }
            else {
                this.selectedCompositeSelectionSetLabel.text("");
            }
        }

        public _setCurrentCompositeSelectionSetData(compositeSelectionSetData) {
            this.currentCompositeSelectionSet = compositeSelectionSetData;
            this._updateSelectionSetLabel();
        }

        public setParameterValue(newValue, more?) {
            Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
                this, CompositeSelectionSetParameterControl, this._setCurrentCompositeSelectionSetData, newValue, more);
        }

        public getParameterValue() {
            if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
                return this.initialParameterValue ? this.initialParameterValue : null;
            }
            else if (this.currentCompositeSelectionSet) {
                return Solovis.deepCopy(this.currentCompositeSelectionSet);
            }
            else {
                return null;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }


        public _showSelectedSetContextMenu(e) {
            const self = this;

            if (this.currentCompositeSelectionSet) {
                // NOTE: Do not use autoClickSingleItem here. It's not a good experience if someone is trying
                //   to click the edit link and ends up jumping to another page instead.

                var selectionSetToUse = CompositeSelectionSetParameterControl.serializeParameterValue(self.getParameterValue());

                var links = [];

                if (selectionSetToUse.custom) {
                    links.push({
                        label: "Edit Ad-hoc Set",
                        click: function () {
                            self._showAdHocEditor(selectionSetToUse.custom);
                        }
                    })
                }
                else {
                    links.push({
                        label: "Edit As Ad-hoc Set",
                        click: function () {
                            self._convertToAdHoc(true);
                        }
                    })
                }

                Solovis.UI.PopupLinkPanel.showLinks({
                    offset: { left: e.pageX, top: e.pageY },
                    links: links
                });
            }
        }


        public _showAdHocEditor(adHocSelectionSet: any) {
            var self = this;

            if (adHocSelectionSet) {
                let editorDialog = new CompositeSelectionSetEditorDialog({
                    compositeSetData: adHocSelectionSet,
                    saveCallback: (newCompositeSetData) => {
                        this.setParameterValue({ custom: newCompositeSetData });
                    },
                    saveAsNewCallback: (idAndNewCompositeSetData) => {
                        this.setParameterValue({ id: idAndNewCompositeSetData.compositeSelectionSetId });
                    }
                });

                editorDialog.show();
            }
        }

        public _convertToAdHoc(showEditor?: boolean) {
            const self = this;

            if (this.currentCompositeSelectionSet && this.currentCompositeSelectionSet.id) {
                Solovis.Reports.ReportDataLoader.loadDataSetAsync(
                    "/Solovis/Metadata/CompositeSelectionSetList",
                    { compositeSelectionSetIds: [this.currentCompositeSelectionSet.id], includeData: true },
                    function (response, success) {
                        if (success) {
                            const dataSet = response.result.dataSet;
                            const compositeSelectionSetInfo: any = _.find(dataSet.compositeSelectionSets, function (i: any) { return i.id == self.currentCompositeSelectionSet.id; })
                            if (compositeSelectionSetInfo) {
                                const newCompositeSelectionData = compositeSelectionSetInfo.compositeSelectionSetData;
                                const newParamValue = {
                                    custom: newCompositeSelectionData
                                };

                                if (showEditor) {
                                    self._showAdHocEditor(newCompositeSelectionData);
                                } else {
                                    self.setParameterValue(newParamValue);
                                }
                            }
                            else {
                                Solovis.UI.alert("Unable to find composite selection set for id: " + self.currentCompositeSelectionSet.id);
                            }
                        }
                    },
                    {
                        invokeMethod: "invokeAndWait"
                    });
            }
        }


        public _toggleSelectorDialog(selectionCallback) {
            const self = this;

            var customValue = {};
            if (self.currentCompositeSelectionSet && self.currentCompositeSelectionSet.custom) {
                // We'll reuse the custom value so you don't lose your query when re-selecting (Ad-hoc).
                customValue = self.currentCompositeSelectionSet.custom;
            };

            Solovis.Reports.ReportDataLoader.loadDataSetAsync(
                "/Solovis/Metadata/CompositeSelectionSetList",
                {},
                function (response) {
                    var options = [];

                    options.push({ label: "(Ad-hoc)", entry: { custom: customValue } });

                    $(response.result.dataSet.compositeSelectionSets).each(function (i, set: any) {
                        var option = {
                            id: set.id,
                            label: set.name,
                            entry: set
                        };

                        if (set.category) {
                            option.label = option.label + " (" + set.category + ")";
                        }

                        options.push(option);
                    });

                    var dialog = new Solovis.UI.Dialogs.StringFilterListDialog({
                        stringFilterListControlOptions: {
                            listItems: options
                        },

                        title: "Select Composite Selection Set",
                        showClearButton: true,

                        selectCallback: function (item) {
                            if (item && item.entry && item.entry.custom) {
                                self._showAdHocEditor(item.entry.custom);
                            } else {
                                self.setParameterValue(item ? item.entry : null);
                            }
                        }
                    });
                },
                {
                    invokeMethod: "invokeAndWait"
                });
        };
    }


}